// JavaScript Document
var speed = 200;
var cubeClasses = ['.strategy', '.research', '.community', '.publish', '.scale', '.story']
var towerElements = [
  {
    'id': 1,
    'class': '.strategy',
    'rotate': '40',
  },
  {
    'id': 2,
    'class': '.research',
    'rotate': '8',
  },
  {
    'id': 3,
    'class': '.community',
    'rotate': '-30',
  },
  {
    'id': 4,
    'class': '.publish',
    'rotate': '-18',
  },
  {
    'id': 5,
    'class': '.scale',
    'rotate': '20',
  },
  {
    'id': 6,
    'class': '.story',
    'rotate': '30',
  },
];

towerElements.forEach(function (el) {
  $('.cube' + el.id).click(function () {
    var my_cube = el.class;
    var rest_cubes = cubeClasses.filter((c) => (c !== my_cube)).join(',');
    $('.twr').css('transform', 'rotateY(' + el.rotate + 'deg)');
    towerElements.forEach((t) => {
      $('.cube' + t.id + ' .face').toggleClass('filter', t.id === el.id);
    });
    $(rest_cubes).addClass('show-out');
    setTimeout(function () {
      $(my_cube).toggleClass('hide', false);
      $(rest_cubes)
        .toggleClass('hide', true)
        .addClass('show-in')
        .removeClass('show-out');
    }, speed);
    setTimeout(function () {
      $(my_cube).removeClass('show-in');
    }, speed * 2);
  });
})



// WEBPACK FOOTER //
// ./scripts/libraries/tower.js